// Generated file - do not change manually!

/**
 * Defines which separator style will be applied for the list items.
 */
export enum ListSeparators {
  /**
   * Separators between the items including the last and the first one.
   */
  All = 'All',

  /**
   * Separators between the items. <b>Note:</b> This enumeration depends on the theme.
   */
  Inner = 'Inner',

  /**
   * No item separators.
   */
  None = 'None'
}
